<template>
  <div
    class="step-content"
    :class="[useGridLayout, widerStepContent, contentMargin]"
  >
    <div
      class="step-content__center"
      :class="[width, centerMargin]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'StepContent',

  // Mixins
  mixins: [
    theme
  ],

  // Props
  props: {
    width: {
      type: String,
      default: ''
    },
    contentMargin: {
      type: String,
      default: 'sm:mb-45' // Default margin
    },
    centerMargin: {
      type: String,
      default: 'mb-20' // Default margin for center
    },
    disableGrid: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    useGridLayout () {
      return this.$route.meta.disableGridLayout || this.disableGrid ? '' : 'step-content--grid'
    },

    widerStepContent () {
      return this.$route.meta.widerStepContent ? 'step-content__wider-content' : ''
    }
  }
}
</script>

<style scoped lang="scss">
.step-content {
  @apply container gap-[20px] flex flex-col;

  &__wider-content {
    @apply md:px-30;
  }

  &--grid {
    @apply grid-cols-1;

    @screen lg {
      @apply grid;

      grid-template-columns: 320px 1fr 320px;
    }
  }

  &__container {
    @apply mb-20 mx-auto flex flex-col border-1 p-30 items-center rounded-10 font-display;

    &--left {
      @apply mt-20;

      @screen md {
        @apply mb-45 mt-0;
      }
    }

    &--right {
      @screen md {
        @apply mb-45;
      }
    }

    @screen md {
      @apply max-w-320 mb-0;
    }

    &-title {
      @apply font-bold text-2xl;
    }

    &-body {
      @apply font-bold text-xl opacity-50;
    }

    img {
      @apply my-10 mx-20;
    }

    &.hidden {
      @apply hidden;
    }
  }

  &__center {
    @apply mx-auto w-full order-first col-start-2;

    @screen sm {
      @apply mb-0;
    }

    @screen lg {
      order: initial;
    }
  }
}
</style>
